__turbopack_context__.v({
  "actionsFooter": "klVljG_actionsFooter",
  "bar": "klVljG_bar",
  "footer": "klVljG_footer",
});
